import { useContext, useEffect, useState } from 'react'
import { getGalerias } from '../services/galerias.service'
import { galeriasType } from '../types'
import { TenantsContext } from '../../../context/tenants.context'
import { useDeviceId } from '../../../hooks/deviceId.hook'
import { hash } from '../../../utils/hashFunction'

export const useGalerias = () => {
  const [galerias, setGalerias] = useState<galeriasType[]>([])
  const [loading, setLoading] = useState(true)
  const { tenant } = useContext(TenantsContext)
  const { deviceId, loading: loadingDeviceId } = useDeviceId()

  useEffect(() => {
    const fetchGalerias = async () => {
      setLoading(true)
      try {
        const clave = await hash(deviceId + 'lugares2017')
        const res = await getGalerias(tenant, deviceId, clave)
        setGalerias(res.data)
      } catch (err) {
        console.log(err)
      } finally {
        setLoading(false)
      }
    }

    if (!loadingDeviceId && deviceId) {
      fetchGalerias()
    }
  }, [deviceId, loadingDeviceId, tenant])

  return { galerias, loading }
}
